module.exports = __webpack_public_path__ + "img/responsaveis_temas.7c113b59.png";